import { loader } from 'graphql.macro';
import { useQuery } from '@apollo/client';
import { get } from 'lodash';

import { useNotificationContext } from '../context/notification-context';
import { BankType } from '../definitions.d';

const BANKS_QUERY = loader('../graphql/banks.graphql');

interface BanksQueryResponse {
  banks: BankType[];
  loading?: boolean;
  error?: Error;
}

const useBanksQuery = (hasActiveAccount?: boolean): BanksQueryResponse => {
  const { showNotification } = useNotificationContext();
  const { data, loading, error } = useQuery(BANKS_QUERY, {
    variables: { hasActiveAccount },
    onError: (e) => {
      showNotification(e.message, 'error');
    }
  });
  return { banks: get(data, 'banks', []), loading, error };
};

export default useBanksQuery;
